import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import useSWR from "swr";
import Spinner from "./components/Spinner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Image from "./components/Image";
import Breadcrumb from "./components/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./../sass/style.scss";
import {
    faCalendarAlt,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const url = window.location.pathname;
const fetcher = (url) => axios.get(url).then((res) => res.data);

function Online() {
    const { data, error } = useSWR("/api" + url, fetcher);

    return data ? (
        <>
            <Header data={data.header} inPage={true} />
            <Breadcrumb
                background={data.page.file}
                title={data.page.category_language.name}
            >
                <li>
                    <a href={window.location.href}>
                        {data.page.category_language.name}
                    </a>
                </li>
            </Breadcrumb>

            <section className="blog">
                <div className="container py-4">
                    <div className="row">
                        <div
                            className="col-12"
                            dangerouslySetInnerHTML={{
                                __html: data.page.category_language.contents,
                            }}
                        ></div>
                    </div>
                </div>
            </section>
            <Footer data={data.footer} inPage={true} />
        </>
    ) : (
        <Spinner />
    );
}

ReactDOM.render(<Online />, document.getElementById("root"));
